export default {
  areaCN: {
    "China":"国产",
    "America":"美洲",
    "Asia":"亚洲",
    "Europe":"欧洲",
    "Australia":"澳洲",
    "国产":"国产",
    "美洲":"美洲",
    "亚洲":"亚洲",
    "欧洲":"欧洲",
    "澳洲":"澳洲"
  },
  areaEN: {
    "国产":"China",
    "美洲":"America",
    "亚洲":"Asia",
    "欧洲":"Europe",
    "澳洲":"Australia",
    "China":"China",
    "America":"America",
    "Asia":"Asia",
    "Europe":"Europe",
    "Australia":"Australia",
  },
}
